import { ISearchResponse } from '@sales-center/common'
import { unwrapResult } from '@reduxjs/toolkit'
import { useEffect, useState } from 'react'
import { useAppDispatch } from '../hooks/useAppDispatch'
import { getLocationOpps } from './api'
import { OppSummary } from './typings'

export const useGetLocationOppsByPage = (
  externalLinkId: string,
  page: number,
  perPage: number,
) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'fail' | 'success'>(
    'idle',
  )

  const [result, setResult] = useState<ISearchResponse<OppSummary>>({
    count: 0,
    items: [],
    skip: 0,
    take: perPage,
  })

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')

        const result = await dispatch(
          getLocationOpps({ externalLinkId, page, perPage }),
        )

        if (mounted) {
          if (getLocationOpps.fulfilled.match(result)) {
            unwrapResult(result)
            result.payload.items.map((i) => {
              if (i.createdDate !== null)
                i.createdDate = new Date(i.createdDate)
              if (i.closedDate !== null) i.closedDate = new Date(i.closedDate)
            })
            setResult(result.payload)
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, externalLinkId, page, perPage])

  return { status, result }
}
